(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hl-product-layout"] && !Shopify.designMode) return;
  try {
    if (!window.hlColorChoiceGuard) {
    window.hlColorChoiceGuard = true;
    const ensureColor = (event) => {
      const section = document.querySelector('.product-information');
      const fieldset = section?.querySelector('[data-hl-color-option]');
      if (!fieldset || fieldset.querySelector('input:checked')) return;
      const target = event.target;
      const isPurchase = event.type === 'submit'
        ? target.matches('form[action*="/cart/add"]')
        : target.closest('.add-to-cart-button, .sticky-add-to-cart__button');
      if (!isPurchase) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      fieldset.scrollIntoView({ block: 'center', behavior: 'auto' });
      const input = fieldset.querySelector('input');
      input?.focus({ preventScroll: true });
      input?.reportValidity();
    };
    document.addEventListener('click', ensureColor, true);
    document.addEventListener('submit', ensureColor, true);

    document.addEventListener('change', (event) => {
      const colorInput = event.target.closest?.('[data-hl-color-option] input[type="radio"]');
      if (!colorInput) return;
      const productSection = colorInput.closest('.product-information');
      const gallery = productSection?.querySelector('.product-information__media');
      if (!gallery) return;
      requestAnimationFrame(() => gallery.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      }));
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
